
import ArrowIcon from '../icons/ArrowIcon.vue';
import SearchIcon from '../icons/SearchIcon.vue';
import { mapActions, mapGetters } from 'vuex';
import { debounce } from 'lodash';
import { SymbolTypes } from '~/types/models/symbol';
import TickerSearchCard from './TickerSearchCard.vue';
import TickerSearchCardSkeleton from '../atom/skeleton/TickerSearchCardSkeleton.vue';

export default {
  name: 'TickerSearchModal',
  components: {
    ArrowIcon,
    SearchIcon,
    TickerSearchCard,
    TickerSearchCardSkeleton,
  },
  props: {
    selectedTickers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentTab: SymbolTypes.STOCKS,
      tabs: [
        {
          type: SymbolTypes.STOCKS,
          label: 'stock_symbol_type_tag',
        },
        {
          type: SymbolTypes.ETF,
          label: 'etf_tag',
        },
        {
          type: SymbolTypes.CRYPTO,
          label: 'stocks_table_header_cryptocurrency_short',
        },
      ],
      query: {
        orderBy: 'followerCount',
        orderByDirection: 'descending',
        isFollowed: false,
        isFollowingPriceChange: false,
        query: '',
        symbolType: SymbolTypes.STOCKS,
        isPrimaryTicker: true,
        includeStockDetails: false,
      },
      pagination: {
        // A bit of a specific number, but it ensures that we have enough results to fill the screen on mobile
        limit: 14,
        page: 1,
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters('stocks', ['stocks']),
    filteredStocks() {
      if (!this.stocks) return [];
      if (!this.selectedTickers.length) return this.stocks;
      return this.stocks.filter(
        (stock) =>
          !this.selectedTickers.some((t) => t.symbolId === stock.symbolId)
      );
    },
  },
  watch: {
    'query.query': debounce(function () {
      this.resetAndSearch();
    }, 400),
    currentTab(newTab) {
      this.query.symbolType = newTab;
      this.resetAndSearch();
    },
  },
  async mounted() {
    document.body.style.overflow = 'hidden';

    await this.searchStocks();
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
  methods: {
    ...mapActions('stocks', ['getStocks', 'getNextStocks']),
    handleCardClick(ticker) {
      this.$emit('tickerSelected', ticker);
    },
    resetAndSearch() {
      this.pagination.page = 1;
      this.infiniteId++;
      this.searchStocks();
    },
    async searchStocks() {
      this.loading = true;
      try {
        await this.getStocks({
          query: this.query,
          pagination: this.pagination,
        });
      } finally {
        this.loading = false;
      }
    },
    async infiniteScroll($state) {
      if (this.stocks.length < this.pagination.limit) {
        $state.complete();
        return;
      }
      this.pagination.page++;
      try {
        await this.getNextStocks({
          query: this.query,
          pagination: this.pagination,
        });

        if (this.stocks.length < this.pagination.page * this.pagination.limit) {
          $state.complete();
        } else {
          $state.loaded();
        }
      } catch {
        $state.error();
      }
    },
  },
};
